export const SENTRY_DSN = process.env.VUE_APP_SENTRY_DSN;
export const SENTRY_ENVIRONMENT = process.env.VUE_APP_SENTRY_ENVIRONMENT || 'production';
